import { render } from "./ShowInfo.vue?vue&type=template&id=b8ac14e8"
import script from "./ShowInfo.vue?vue&type=script&lang=js"
export * from "./ShowInfo.vue?vue&type=script&lang=js"

import "./ShowInfo.vue?vue&type=style&index=0&id=b8ac14e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__